module.exports = __webpack_public_path__ + "media/images/icon-kakaotalk@3x-5dd969e838c29cbc7f3ba4f15c1e6d63.png";